(function () {
  if (window.PedalInsidersJoin) return;

  var CODES = { kit: 'INSIDER-ISD20', pro: 'INSIDERPRO-ISD30' };
  var OURS = [CODES.kit, CODES.pro];
  var PRO_THRESHOLD_CENTS = 27000;
  var tag = document.querySelector('script[data-insiders-join]');
  var isMember = !!(tag && tag.getAttribute('data-member') === 'true');

  var running = null;
  var again = false;
  var timer = null;
  var notApplicable = {};

  function isQualifying(item) {
    var text = ((item.product_title || '') + ' ' + (item.title || '')).toLowerCase();
    return text.indexOf('insiders 2027') !== -1 && text.indexOf('speed suit') === -1;
  }

  function isJersey(item) {
    return isQualifying(item) && String(item.product_title || '').toLowerCase().indexOf('jersey') !== -1;
  }

  function wantedCode(cart) {
    if (isMember) return null;
    var spend = 0;
    var jersey = false;
    cart.items.forEach(function (item) {
      if (!isQualifying(item)) return;
      spend += Number(item.original_line_price || 0);
      if (isJersey(item)) jersey = true;
    });
    if (!jersey) return null;
    return spend >= PRO_THRESHOLD_CENTS ? CODES.pro : CODES.kit;
  }

  function signature(cart, code) {
    return code + '#' + cart.items.map(function (i) { return i.key + ':' + i.quantity; }).join('|');
  }

  function codesOf(cart) {
    return (cart.discount_codes || []).map(function (c) {
      return { code: String(c.code || ''), applicable: !!c.applicable };
    });
  }

  function isOurs(code) {
    return OURS.indexOf(code.toUpperCase()) !== -1;
  }

  function request(url, body) {
    return fetch(url, {
      method: body ? 'POST' : 'GET',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: body ? JSON.stringify(body) : undefined
    }).then(function (r) { return r.ok ? r.json() : null; });
  }

  function setCodes(list) {
    return request('/cart/update.js', { discount: list.join(',') });
  }

  function refreshed(cart) {
    if (!cart) return cart;
    try { document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } })); } catch (e) {}
    try { document.dispatchEvent(new CustomEvent('cart:build')); } catch (e) {}
    return cart;
  }

  function sync() {
    return request('/cart.js').then(function (cart) {
      if (!cart || !cart.items) return null;

      var want = wantedCode(cart);
      if (want && notApplicable[signature(cart, want)]) want = null;

      var current = codesOf(cart);
      var others = current.filter(function (c) { return !isOurs(c.code); }).map(function (c) { return c.code; });
      var ours = current.filter(function (c) { return isOurs(c.code); });

      if (want && ours.length === 1 && ours[0].code.toUpperCase() === want) {
        if (ours[0].applicable) return cart;
        notApplicable[signature(cart, want)] = true;
        return setCodes(others).then(refreshed);
      }
      if (!want && !ours.length) return cart;

      return setCodes(want ? others.concat([want]) : others).then(function (updated) {
        if (updated && want) {
          var applied = codesOf(updated).filter(function (c) { return c.code.toUpperCase() === want; })[0];
          if (!applied || !applied.applicable) {
            notApplicable[signature(updated, want)] = true;
            return setCodes(others).then(refreshed);
          }
        }
        return refreshed(updated);
      });
    });
  }

  function run() {
    if (running) {
      again = true;
      return running;
    }
    running = sync()
      .catch(function () { return null; })
      .then(function (cart) {
        running = null;
        if (again) {
          again = false;
          schedule();
        }
        return cart;
      });
    return running;
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(run, 250);
  }

  ['cart:updated', 'cart:build', 'cart:open', 'ajaxProduct:added'].forEach(function (name) {
    document.addEventListener(name, schedule);
  });
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) schedule();
  });

  window.PedalInsidersJoin = { sync: run };
  schedule();
})();
